module.exports = __webpack_public_path__ + "static/mens-group-d69a6e99acf38c3ba69727dde3b27bb4.jpg";